import axios from 'axios';
import { API_URL } from '../../global/components/Constants';

export const saveTopicComponent = async (payload) => {
    try {
        const response = await axios.post(`${API_URL}topic/save_topic_component`, payload, {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateTopicCompCol = async (payload) => {
  try {
      const response = await axios.post(`${API_URL}topic/update_topic_comp_column`, payload, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
      });
      return response.data;
  } catch (error) {
      throw error;
  }
}

export const swapTopicComponentRank = async (payload) => {
  try {
      const response = await axios.post(`${API_URL}topic/swap_topic_comp_rank`, payload, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
      });
      return response.data;
  } catch (error) {
      throw error;
  }
}

export const getTopics = async (page, query) => {

    try {
      const response = await axios.get(
        `${API_URL}topic/topics?page=${page}&query=${query}`, 
        {withCredentials: true}
      );
      const obj = response.data;
      if(obj.Success){
          if(obj.Data.length > 0){
            return obj.Data;
          }
      }
  
      return [];
  
    } catch (error) {
      return [];
    }
}

export const getTopTopics = async () => {
  try {
    const response = await axios.get(`${API_URL}topic/top_topics`, {withCredentials: true});
    const obj = response.data;
    if(obj.Success){
        if(obj.Data.length > 0){
          return obj.Data;
        }
    }
    return [];
  } catch (error) {
    return [];
  }
}

export const getCategoryTopics = async (category, page, query) => {

    try {
      const response = await axios.get(
        `${API_URL}topic/topics_by_category?category=${category}&page=${page}&query=${query}`, 
        {withCredentials: true}
      );
      const obj = response.data;
      if(obj.Success){
          if(obj.Data.length > 0){
            return obj.Data;
          }
      }
  
      return [];
  
    } catch (error) {
      return [];
    }
}

export const getUserTopics = async (page, query) => {

  try {
    const response = await axios.get(
      `${API_URL}topic/user_topics?page=${page}&query=${query}`, 
      {withCredentials: true}
    );
    const obj = response.data;
    if(obj.Success){
        if(obj.Data.length > 0){
          return obj.Data;
        }
    }

    return [];

  } catch (error) {
    return [];
  }
}

export const getTopicComponents = async (slug) => {
  
  try {

    const response = await axios.get(`${API_URL}topic/topic_components?topicSlug=${slug}`);
    const obj = response.data;
    if(obj.Success){
        if(obj.Data.length > 0){
          return parseTopicComponents(obj.Data);
        }
    }

    return [];

  } catch (error) {
    return [];
  }
}

export const getPresentationInit = async (slug) => {
  
  try {
    const response = await axios.get(`${API_URL}topic/topic_presentation_init?topicSlug=${slug}`);
    const obj = response.data;
    if(obj.Success){
        if(obj.Data.length > 0){
          const parsedResult =  parseTopicComponents(obj.Data);
          localStorage.setItem("components", JSON.stringify(parsedResult));
          const start = parsedResult.find(x=>x.Prev == 'start');
          return (start != null)? start: null;
        }
    }

    return [];

  } catch (error) {
    return [];
  }
}

function parseTopicComponents(data){
  let result = [];
  data.forEach((elem) => {
      if(elem.ContainerId == 0){ //Get only components that are not container items 
          if(elem.ComponentType == "container"){
              const sub = data.filter(x => x.ContainerId == elem.Id);
              result.push({...elem, Sub: sub});
          }
          else{
              result.push({...elem, Sub: []});
          }
      }
  });
  return result;
}

export const getTopicCount = async (category) => {
  try {
    const response = await axios.get(`${API_URL}topic/topic_count?category=${category}`);
    const obj = response.data;
    if(obj.Success){
        if(obj.Data != null){
          return obj.Data;
        }
    }

    return null;

  } catch (error) {
    return null;
  }
}

export const deleteTopicComponent = async (payload) => {
  try {
      const response = await axios.post(`${API_URL}topic/delete_topic_component`, payload, {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
      });
      return response.data;
  } catch (error) {
      throw error;
  }
}